import "react-native-url-polyfill/auto";
import { createClient } from "@supabase/supabase-js";
import { Database } from "./Supabase.types";
import AsyncStorage from "@react-native-async-storage/async-storage";

const server = createClient<Database>(
  process.env.EXPO_PUBLIC_SUPABASE_HOST as string,
  process.env.EXPO_PUBLIC_SUPABASE_KEY as string,
  {
    auth: {
      storage: AsyncStorage,
      autoRefreshToken: false,
      persistSession: true,
      detectSessionInUrl: false,
    },
  }
);

export default server;
